import API from './apiConfig';

export const register = async (formData) => {
  try {
    const response = await API.post('/register', formData, {
      headers: {
        "Content-Type": 'multipart/form-data',
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStudentForRegistration = async (formData) => {
  try {
    const response = await API.post('/user', formData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStudentById = async (id) => {
  try {
    const response = await API.get(`/user/${id}`);
    return response.data.data;
  } catch (error) {
    console.error(`Error fetching student ${id}:`, error);
    throw error;
  }
};

export const updateStudentById = async (id, formData) => {
  try {
    const response = await API.put(`/user/${id}`, formData);
    return response;
  } catch (error) {
    console.error("Error during API call:", error);
    throw error;
  }
};

export const postPassportById = async (formData) => {
  const id = localStorage.getItem("user_id")
    ? JSON.parse(localStorage.getItem("user_id"))
    : "0000";
  try {
    const response = await API.post(`/passport/${id}`, formData, {
      headers: {
        "Content-Type": 'multipart/form-data',
      }
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching student ${id}:`, error);
    throw error;
  }
};

export const updatePassportById = async (formData) => {
  const id = localStorage.getItem("user_id")
    ? JSON.parse(localStorage.getItem("user_id"))
    : "0000";
  try {
    const response = await API.put(`/passport/${id}`, formData, {
      headers: {
        "Content-Type": 'multipart/form-data',
      }
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching student ${id}:`, error);
    throw error;
  }
};

export const getPassportById = async () => {
  const id = localStorage.getItem("user_id")
    ? JSON.parse(localStorage.getItem("user_id"))
    : "0000";
  try {
    const response = await API.get(`/passport/${id}`);
    return response.data.data;
  } catch (error) {
    console.error(`Error fetching student ${id}:`, error);
    throw error;
  }
};

export const getFormCheck = async (id) => {
  try {
    const response = await API.get(`/formcheck/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getAnnouncement = async (id) => {
  try {
    const response = await API.get(`/announcement/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getCanvas = async (id) => {
  try {
    const response = await API.get(`/canvas/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getQR = async (id) => {
  try {
    const response = await API.get(`/qr/${id}`, { responseType: "blob", });
    return response.data;
  } catch (error) {
    throw error;
  }
}